<template>
  <usersTable></usersTable>
</template>

<script>
import usersTable from "@/components/Tables/Table";

export default {
  name: "UserRightsManagement",
  components: {
    usersTable,
  },
  data() {
    return {
      search: "",
      columns: [
        { text: "ID", align: "start", value: "id" },
        { text: "Фамилия", value: "last_name" },
        { text: "Имя", value: "first_name" },
        { text: "Возраст", value: "age" },
        { text: "Роль", value: "role" },
        { text: "Права", value: "rights" },
      ],
      users: [
        {
          id: 1,
          age: 40,
          first_name: "Андрей",
          last_name: "Зайцев",
          department: "Разработчики",
          role: "Работник",
          rights: "",
        },
        {
          id: 22,
          age: 21,
          first_name: "Дмитрий",
          last_name: "Игнашкин",
          department: "Разработчики",
          role: "Супер-админ",
          rights: ["Добавить", "Удалить", "Изменить"],
        },
        {
          id: 33,
          age: 30,
          first_name: "Нина",
          last_name: "Караваева",
          department: "Разработчики",
          role: "Особый сотрудник",
          rights: "",
        },
        {
          id: 88,
          age: 35,
          first_name: "Михаил",
          last_name: "Романец",
          department: "Аналитика",
          role: "Вообще важный",
          rights: "",
        },
        {
          id: 34,
          age: 44,
          first_name: "Юрий",
          last_name: "Гамов",
          department: "Аналитика",
          role: "Руководитель проектов",
          rights: "",
        },
      ],
      positions: [
        { id: 1, name: "Разработчик" },
        { id: 2, name: "Аналитик" },
        { id: 3, name: "Специалист по внедрению" },
        { id: 4, name: "HR" },
        { id: 5, name: "Бизнес аналитик" },
        { id: 6, name: "Менеджер проектов" },
      ],
    };
  },
  methods: {
    alertMessage(item) {
      console.log(item);
    },
  },
};
</script>

<style scoped></style>
